import styled from 'styled-components';
import BaseEmailIcon from '#/shared/components/GeneratedIcons/trimet/Email';
import { ClearInput, ClearButton } from '#/shared/components/Styled';
import { GTM_DATA_ATTRIBUTE } from '#/shared/constants';
import GTM_HANDLES from '#/shared/gtm-handles';

export const SignupForm = styled.form`
  border-radius: 5px;
  padding: 12px;
  background-color: ${props => props.theme.inverseBackgroundColor2};
  display: flex;
  flex-flow: column;
  flex: 1 1 auto;
  max-width: 400px;
`;

export const SignupFormMessage = styled.div`
  text-transform: uppercase;
  flex: 1 1 auto;
  font-size: 0.8em;
  display: flex;
  align-items: center;
  color: ${props => props.theme.inverseFontColor1};
`;

export const SignupFormMessageText = styled.div`
  flex: 1 1 auto;
`;

export const SignupFormInput = styled(ClearInput).attrs(props => ({
  'aria-label': props.placeholder,
}))`
  border-color: ${props => props.theme.inverseFontColor2};
  color: ${props => props.theme.inverseFontColor1};
  font-weight: 300;
  margin: 5px 0 15px;
  flex: 1 1 auto;
  padding: 6px 0;
  font-size: 1.8em;
  border-bottom: 1px solid ${props => props.theme.inputBorderColorReverse};

  &::placeholder {
    color: ${props => props.theme.inverseFontColor2};
  }
  &:focus {
    border-bottom: 1px solid
      ${props => props.theme.inputBorderColorFocusReverse};
  }
`;

export const SignupFormError = styled.div`
  flex: 1 1 auto;
  color: ${props => props.theme.warnColor};
  margin-bottom: 15px;
  padding-left: 8px;
`;

export const EmailIcon = styled(BaseEmailIcon).attrs(props => ({
  width: 15,
  height: 15,
  fill: props.theme.inverseFontColor1,
  role: 'presentation',
}))`
  flex: 0 0 20px;
  margin-right: 5px;
  padding-bottom: 2px;
`;

export const SignupFormButton = styled(ClearButton).attrs({
  type: 'submit',
  [GTM_DATA_ATTRIBUTE]: GTM_HANDLES.routeAlerts.emailSignupButton,
})`
  pointer-events: ${props => (props.disabled ? 'none' : 'initial')};
  background-color: ${props =>
    props.disabled
      ? props.theme.inactiveColor
      : props.theme.inverseButtonColor1};
  border-radius: 5px;
  border: 0;
  font-family: inherit;
  text-decoration: none;
  padding: 8px;
  color: ${props => props.theme.inverseFontColor1};
  width: 100%;
  flex: 0 0 auto;
  max-width: 175px;
  align-self: center;
  text-align: center;
  font-size: 1em;
  @media (any-hover: hover) {
    &:hover {
      background-color: ${props => props.theme.inverseButtonColor2};
      cursor: pointer;
    }
  }
  &:focus,
  &:active {
    background-color: ${props => props.theme.inverseButtonColor1};
  }
`;
